<template>
  <div>
    <crud-layout-search ref="crudLayoutSearch" :params="params" :inputs="inputs" :interface="nmInterface" :id="id"
      clean-layout>
      <page-table slot="page-table" slot-scope="dataPageTable" v-bind="dataPageTable"
        @action-button="dataPageTable.actionButton" @show-message="dataPageTable.showMessage">
        <template slot="table" slot-scope="dataTable">
          <jt-data-table v-bind="dataTable" multiselect selection-force class="table-crud" :row-buttons="false"
            @action-button="(_event, _clickedRecord, _jtDataTableComponent) =>
              onActionClick(
                _event,
                _clickedRecord,
                _jtDataTableComponent,
                dataTable.actionButton
              )
              " @show-message="dataTable.showMessage" @selection="(_event) => onSelectRow(_event)"
            @toggle-change="(_event) => onToggleChange(_event)">
          </jt-data-table>
        </template>
      </page-table>
    </crud-layout-search>
    <modal v-if="modalData.show" ref="modalMtr" :show="modalData.show" v-bind="modalData" maximized
      @input="(show) => (modalData.show = show)" @action-button="actionButtonUpdate" @search-found="searchFound"
      @form-reset="formModalReset" />

    <type-integration ref="typeIntegration" @on-save="() => this.$refs.crudLayoutSearch.refresh()" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'
import ClientGeneratorResidueDialog from './ClientGeneratorResidueDialog'
import TypeIntegration from './TypeIntegration'

const {
  page,
  pageTable,
  CrudLayoutSearch,
  form,
  input,
  compositions,
  composition,
  modal
} = JtCrud
@Component({
  mixins: [page],
  components: {
    CrudLayoutSearch,
    page,
    pageTable,
    JtDataTable,
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition,
    modal,
    TypeIntegration
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ClientResidueGenerator extends Vue {
  idsToActivateOrInactivate = [];
  modalData = { show: false };

  clientGeneratorResidueData = null;
  calledInterface = null;
  start = 0;
  templateName = null;

  async openSerachModal (_clickedRecord) {
    this.$refs.typeIntegration.openSerachModal(_clickedRecord)
  }

  async icActivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(true)
  }

  async icInactivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(false)
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton(
        'icActivateInBlock',
        this.icActivateInBlock
      )
      this.$refs.crudLayoutSearch.onButton(
        'icInactivateInBlock',
        this.icInactivateInBlock
      )
    } catch (error) {
      console.error(error)
    }
  }

  onToggleChange (_form) {
    this.$q
      .dialog({
        title: 'IS_CLIENTE_GENERATOR_RESIDUE_COMPACTOR',
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: true
      })
      .onOk(async () => {
        const param = {
          compactor: _form.newValue,
          id: _form.props.row.id
        }
        await repository.resolveLogic(
          'clientGeneratorResidue.updateCompactor',
          param
        )
        this.$refs.crudLayoutSearch.refresh()
      })
      .onCancel(() => {
        _form.props.row[_form.col.field] = !_form.newValue
      })
  }

  get inputs () {
    if (!this.elements) return []
    const generatorInput = this.elements[0].inputs.find(
      (input) => input.model == 'generator'
    )
    if (!generatorInput) {
      throw new 'Não foi encontrado generatorInput'()
    }
    generatorInput.type = 'generator_search'
    return this.elements[0].inputs
  }

  onSelectRow (_event) {
    this.idsToActivateOrInactivate = []
    _event.forEach((_selectedRecord) => {
      this.idsToActivateOrInactivate.push(_selectedRecord.id)
    })
  }

  onActionClick (_event, _clickedRecord, _jtDataTableComponent, _actionButton) {
    const { name, label } = _event
    switch (name) {
      case 'btMtr':
        _clickedRecord.clientGeneratorResidue = _clickedRecord.id
        this.identifyInterface(_clickedRecord.clientGeneratorResidueMtr)
        this.clientGeneratorResidueData = { ..._clickedRecord }
        this.openModalMtr(this.calledInterface, this.setDadosToOpenModal(_clickedRecord))
        break
      case 'btAddIntegration':
        this.openSerachModal(_clickedRecord)
        break
      default:
        _actionButton(_event, _clickedRecord, _jtDataTableComponent)
        break
    }
  }

  identifyInterface (clientGeneratorResidueMtrId) {
    if (clientGeneratorResidueMtrId != null) {
      this.calledInterface = 'clientGeneratorResidueMtr.alterar'
    } else {
      this.calledInterface = 'clientGeneratorResidueMtr.gravar'
    }
  }

  setDadosToOpenModal (_clickedRecord) {
    if (this.calledInterface == 'clientGeneratorResidueMtr.alterar') {
      return (_clickedRecord = {
        ..._clickedRecord,
        id: _clickedRecord.clientGeneratorResidueMtr
      })
    }
    return (_clickedRecord = { ..._clickedRecord, id: null })
  }

  async actionButtonUpdate (button, params) {
    if (!this.templateName && this.start > 0) {
      return
    }
    params.template = params.landfillEnvironmentalAgencyMtr
    this.$refs.crudLayoutSearch.actionButton(button, params, this)
    this.modalData.show = false
  }

  async openModalMtr (actionButton, params) {
    const forms = await repository.resolve(actionButton, params)
    this.modalData = {
      show: true,
      forms: forms,
      label: this.$gettext('MTR_CONTRACT_ITEM'),
      params: params,
      parent: this
    }
  }

  async searchFound (data) {
    this.templateName = data.template.idField
    if (this.calledInterface == 'clientGeneratorResidueMtr.gravar') {
      const idTemplate = { ...data, template: { ...data.template } }
      this.templateName = data.template.codeField
      this.clientGeneratorResidueData.landfillEnvironmentalAgencyMtr = parseInt(
        data.template.idField
      )
      data = { data, ...this.clientGeneratorResidueData }
      data.id = null
      const dados = await repository.resolveModel(this.calledInterface, data)
      dados.dadosForm = Object.assign(dados.dadosForm, { ...idTemplate })
      this.$refs.modalMtr._props.forms[0].dadosForm = dados.dadosForm
      this.$refs.modalMtr._props.forms[0].relacionamentos =
        dados.relacionamentos
      this.start++
      return
    }
    if (this.start > 0) {
      const templateNumber = parseInt(data.template.idField)
      this.clientGeneratorResidueData.landfillEnvironmentalAgencyMtr =
        templateNumber
      Object.assign(data, { ...this.clientGeneratorResidueData })
      data.id = data.clientGeneratorResidueMtr
      this.templateName = data.template.codeField
      const dados = await repository.resolveModel(this.calledInterface, data)
      dados.dadosForm = Object.assign(dados.dadosForm, { ...data.template })
      this.$refs.modalMtr._props.forms[0].dadosForm = dados.dadosForm
      this.$refs.modalMtr._props.forms[0].relacionamentos =
        dados.relacionamentos
    }
    this.templateName = data.template.codeField
    this.start++
  }

  formModalReset (forms) {
    forms.page._props.forms[0].dadosForm = {
      id: forms.page._props.forms[0].dadosForm.id
    }
    forms.page._props.forms[0].relacionamentos = {}
  }

  dialogUpdateAvailableInBlock (available) {
    if (this.idsToActivateOrInactivate.length == 0) {
      this.$q.dialog({
        title: this.$gettext(
          'IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK_NO_REGISTERS'
        ),
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: false
      })
      return
    }

    const title = this.$gettextInterpolate(
      this.$gettext('IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK'),
      {
        action: available
          ? this.$gettext('ACTIVATE_MSG')
          : this.$gettext('INACTIVATE_MSG')
      }
    )
    this.$q
      .dialog({
        title: title,
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: true
      })
      .onOk(async () => {
        const param = {
          available: available,
          ids: this.idsToActivateOrInactivate
        }
        await repository.resolveLogic(
          'clientGeneratorResidue.updateAvailableInBlock',
          param
        )
        this.$refs.crudLayoutSearch.refresh()
      })
  }

  @Watch('modalData.show')
  setStartToZero () {
    if (this.modalData.show == false) {
      this.start = 0
    }
  }

  get page () {
    return page
  }

  get nmInterface () {
    return this.interface
  }
}
export default ClientResidueGenerator
</script>
<style lang="stylus" scoped>
/deep/ .icInativar { button {
  width: auto;
}}

/deep/ .icAtivar { button {
  width: auto;
}}

.clientGenerator {
  padding-top: 20px;

  .buttons-top-crud {
    display: none;
  }

  .label-crud-search {
    display: none;
  }

  .btNovo-btn i, .icAlterar-btn i, .icAtivar-btn i, .icInativar-btn i {
    padding-right: 10px;
  }

  .crudButtons .card-crud .table-crud .jt-datatable {
    height: 63vh !important;
  }
}

.clientGeneratorModal {
  .cg-content {
    padding: 15px;
  }

  .my-center {
    margin: 25% 0;
  }
}
</style>
